import type { RenderableIsland } from '@hubspot/cms-components';
import * as cmsComponents from '@hubspot/cms-components';
import { ClientRenderContextProvider } from '@hubspot/cms-components';
import { Suspense } from 'react';
import ReactDOMClient from 'react-dom/client';

const buildIslandIdentifierPrefix =
  cmsComponents.buildIslandIdentifierPrefix || ((id) => id);

export function clientRenderIsland(
  renderableIsland: RenderableIsland,
  Component: React.ComponentType<any>
) {
  const {
    island,
    rootElement,
    postHydration,
    pageUrl,
    islands,
    basePath,
    WrapperModule,
  } = renderableIsland;
  let reactRoot: any;

  const rootOptions = {
    // Ensure useId is unique across island roots
    identifierPrefix: buildIslandIdentifierPrefix(renderableIsland.island.id),
  };

  let innerComponent = <Component islandId={island.id} {...island.props} />;
  if (WrapperModule) {
    innerComponent = <WrapperModule>{innerComponent}</WrapperModule>;
  }

  const elementsToHydrate = (
    <Suspense fallback={`client hydrate fail/waiting for ${island.id}`}>
      <ClientRenderContextProvider
        pageUrl={pageUrl}
        islands={islands}
        onTopLevelHydrationFinish={postHydration}
        island={island}
        basePath={basePath}
      >
        {innerComponent}
      </ClientRenderContextProvider>
    </Suspense>
  );

  if (island.clientOnly) {
    reactRoot = ReactDOMClient.createRoot(rootElement, rootOptions);
    reactRoot.render(elementsToHydrate);
  } else {
    reactRoot = ReactDOMClient.hydrateRoot(
      rootElement,
      elementsToHydrate,
      rootOptions
    );
  }
  return reactRoot;
}
